export class ScoreManager {
    constructor() {
        this.score = 0;
        this.highScore = this.loadHighScore();
        this.scoreDisplay = document.createElement('div');
        this.scoreDisplay.style.position = 'fixed';
        this.scoreDisplay.style.top = '80px';
        this.scoreDisplay.style.left = '20px';
        this.scoreDisplay.style.fontSize = '28px';
        this.scoreDisplay.style.color = '#fff';
        this.scoreDisplay.style.textShadow = '2px 2px 4px rgba(0,0,0,0.5)';
        this.scoreDisplay.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
        this.scoreDisplay.style.padding = '10px 20px';
        this.scoreDisplay.style.borderRadius = '10px';
        this.scoreDisplay.style.fontWeight = 'bold';
        document.body.appendChild(this.scoreDisplay);
        this.updateScoreDisplay(); // 添加这行，确保初始分数显示为0
    }

    addScore(points) {
        this.score += points;
        this.updateScoreDisplay();
        
        if (this.score > this.highScore) {
            this.highScore = this.score;
            this.saveHighScore();
        }
    }

    getScore() {
        return this.score;
    }

    resetScore() {
        this.score = 0;
        this.updateScoreDisplay();
    }

    updateScoreDisplay() {
        if (this.scoreDisplay) {
            this.scoreDisplay.textContent = `分数: ${this.score}`;
        }
    }

    loadHighScore() {
        const saved = localStorage.getItem('diceGameHighScore');
        return saved ? parseInt(saved) : 0;
    }

    saveHighScore() {
        localStorage.setItem('diceGameHighScore', this.highScore.toString());
    }
}